import {Component, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UsersService} from '../../../Services/users.service';
import {InvoiceDealer} from '../../../Models/InvoiceDealer';
import {DealersService} from '../../../Services/dealers.service';
import {TranslateService} from '@ngx-translate/core';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {CollectionDiscount} from '../../../Models/CollectionDiscount';
import {Grid} from '../../../../shared/Models/grid';
import {DeliveryContact} from '../../../Models/DeliveryContact';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {DealerProfileService} from '../../../Services/dealer-profile.service';
import {CollectionTransportationCost} from '../../../Models/CollectionTransportationCost';
import {IButton} from '../../../../shared/card/card.component';

@Component({
  selector: 'app-view-dealer',
  templateUrl: './view-billing-account.component.html',
  styleUrls: ['./view-billing-account.component.scss']
})
export class ViewBillingAccountComponent implements OnInit {
  public dealerId: number;
  public dealer: any;
  public archive = false;
  public collectionDiscounts: CollectionDiscount[];
  public editCollectionDiscount = false;

  /**
   * Start transportation cost section variables
   * ===========================================
   */
  public collectionTransportationCosts: CollectionTransportationCost[] = [];
  public editCollectionTransportationCost = false;
  public transportationCostDescription?: string;
  /**
   * End transportation cost section variables
   * ===========================================
   */
  public classicBox;
  public lastValue = <any>{};
  public refreshModal;
  public manageProfile;
  public users: SystemUser[] = [];
  public deliveryDealer: SystemUser = new SystemUser();
  public profileOptions = [];
  public currentDealerProfiles = [];
  @ViewChild('usersRowDetail', {static: false}) usersRowDetail: any;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('readdModal', {static: false}) readdModal = null;
  @ViewChild('editPointModal', {static: false}) editPointModal = null;
  public enableSave = true;
  public userGrid: Grid;
  public userArchiveGrid: Grid;
  public editStatus = false;
  public editProfile = false;
  public editBundleInvoice = false;
  public statuses = [
    {label: this.translateService.instant('global.active'), value: InvoiceDealer.INVOICEDEALER_ACTIVE},
    {label: this.translateService.instant('global.on_hold'), value: InvoiceDealer.INVOICEDEALER_ON_HOLD},
    {label: this.translateService.instant('global.inactive'), value: InvoiceDealer.INVOICEDEALER_INACTIVE}
  ];
  public yesNoOptions = [
    {label: this.translateService.instant('global.yes'), value: true},
    {label: this.translateService.instant('global.no'), value: false}
  ];
  toggleDealerPointClass = 'fa-toggle-on';
  private dateFormat: string;
  public advancedButtons: IButton[] = [];
  public syncButton;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dealersService: DealersService,
    private translateService: TranslateService,
    private auth: AuthenticationService,
    private usersService: UsersService,
    private broadcastService: BroadcastService,
    private dealerProfileService: DealerProfileService
  ) {
  }

  ngOnInit() {
    this.syncButton = {
      key: 'sync',
      btnName: this.translateService.instant('admin.exact.sync'),
      method: 'syncWithExact',
      btnCustomClass: 'btn-primary',
      btnIcon: 'fa fa-repeat'
    };

    this.advancedButtons.push(this.syncButton);

    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.dealerId = params['id'];
        this.getDealerItem();
      }
    });
    this.getProfilesOptions();


    this.dateFormat = this.auth.getDateFormat();
  }

  getDealerItem() {
    this.dealersService.getDealer(this.dealerId).subscribe((resp) => {
      if (resp) {
        this.dealer = resp;
        this.lastValue = {dealer: resp};

        this.collectionDiscounts = JSON.parse(JSON.stringify(
          this.dealer.invoiceDealer && this.dealer.invoiceDealer.collectionDiscounts ? this.dealer.invoiceDealer.collectionDiscounts : ''));
        this.editCollectionDiscount = this.collectionDiscounts.length > 0;

        this.collectionTransportationCosts = JSON.parse(JSON.stringify(
          this.dealer.invoiceDealer && this.dealer.invoiceDealer.collectionTransportationCosts ?
            this.dealer.invoiceDealer.collectionTransportationCosts : ''));
        this.editCollectionTransportationCost = this.collectionTransportationCosts.length > 0;

        this.dealer.profiles.forEach((value, key) => {
          this.currentDealerProfiles.push(value.id);
        });

        this.toggleDealerPointClass = this.dealer.dealerPointEnabled ? 'fa-toggle-on' : 'fa-toggle-off';
        return;
      }
      this.router.navigateByUrl('/back-office/crm/dealer/overview');
    });
  }

  getDealer() {
    return InvoiceDealer;
  }

  getDealerProfiles(profiles) {
    if (profiles) {
      return profiles.map(profile => profile.name).join(', ');
    }
    return null;
  }

  getPaymentCondition(paymentType) {
    switch (paymentType) {
      case InvoiceDealer.INVOICEDEALER_paymentCondition_14DAYS:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.14days');
      case InvoiceDealer.INVOICEDEALER_paymentCondition_21DAYS:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.21days');
      case InvoiceDealer.INVOICEDEALER_paymentCondition_30DAYS:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.30days');
      case InvoiceDealer.INVOICEDEALER_paymentCondition_BEFORE_PRODUCTION:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.before_production');
      case InvoiceDealer.INVOICEDEALER_paymentCondition_BEFORE_DELIVERY:
        return this.translateService.instant('doctrine.invoice_dealer.paymentCondition_items.before_delivery');
    }
  }

  refreshGrid($event = null) {
    const dataToRefresh = this.archive ? this.userArchiveGrid.method : this.userGrid.method;
    this.broadcastService.broadcast('refreshDealerGrid', dataToRefresh);
  }

  activateEditStatus() {
    this.editStatus = true;
  }

  activateEditBundleInvoices() {
    this.editBundleInvoice = true;
  }

  saveStatus($event) {
    if (this.editStatus) {
      this.usersService.updateDealerStatus($event.value, this.dealer.id).subscribe(res => {
        this.editStatus = false;
        this.dealer.status = res['status'];
      });
    }
  }

  saveBundleStatus($event) {
    if (this.editBundleInvoice && this.dealer.invoiceDealer) {
      this.usersService.updateDealerBundleInvoice($event.value, this.dealer.invoiceDealer.id).subscribe(res => {
        this.editBundleInvoice = false;
        this.dealer.invoiceDealer.bundleInvoices = res['bundleInvoices'];
      });
    }
  }

  getProfilesOptions() {
    this.dealerProfileService.getProfiles().subscribe((resp) => {
      resp.data.forEach((item, key) => {
        this.profileOptions.push({label: item.name, value: item.id});
      });
    });
  }

  activateEditProfile() {
    this.editProfile = true;
  }

  saveProfile($event) {
    if (this.editProfile && this.dealer) {
      this.dealerProfileService.updateDealerProfile($event, this.dealer.id).subscribe(res => {
        this.editProfile = false;
        this.dealer.profiles = res;
      });
    }
  }

  syncWithExact() {
    this.syncButton.btnCustomClass = 'btn-grey working';
    this.dealersService.sync(this.dealer.id).subscribe((res) => {
      this.syncButton.btnCustomClass = 'btn-primary';
    }, (e) => {
      this.syncButton.btnCustomClass = 'btn-primary';
    });
  }

  calFunction(method: string) {
    this[method]();
  }
}
